import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from '../../../../../environments/environment';

@Injectable({
	providedIn: 'root'
})
export class PucaService {

	constructor(public http: HttpClient) { }

	public getIsMaxApplicationExist(profileId): Observable<any> {
		return this.http.get(environment.BASE_URL_HRD_PUCA + 'puca/isMaxApplicationExist/'+profileId)
	}

	public cancelApplication(payload): Observable<any> {
		return this.http.post(environment.BASE_URL_PUCA + 'das/cancelApplication', payload)
	}
	public getApplicationFormData(profileId): Observable<any> {
		return this.http.get(environment.BASE_URL_HRD_PUCA + 'puca/getApplicationFormData/0/'+profileId)
	}
	public checkEligibility(profileId): Observable<any> {
		return this.http.get(environment.BASE_URL_HRD_PUCA + 'puca/checkEligibility/'+profileId)
	}

	public tAndCAccepted: Subject<boolean> = new Subject();
	public eligibility: Subject<any> = new Subject();
}
